import { render, staticRenderFns } from "./AndiamoUtenteFormComponent.vue?vue&type=template&id=2d55b03d&scoped=true"
import script from "./AndiamoUtenteFormComponent.vue?vue&type=script&lang=js"
export * from "./AndiamoUtenteFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d55b03d",
  null
  
)

export default component.exports